window.addEventListener('DOMContentLoaded', (event) => {
  $('.video-collection').change(function(){
      var active=$(this).val();
      if(active == 'all'){
        $('.product_img_cont').show();
        $('.sb_single_a').removeClass('hide');
      }else{
        $('.sb_single_a').addClass('hide');
        $('.product_img_cont').hide();
        $('.product_img_cont.'+active).show(); 
        $('.sb_single_a.'+active).removeClass('hide'); 
      }
      $(this).blur();
      $('.videos').show();
      $('.product-videos').hide();
      $('.category').removeClass('active');
      $('.sb_single_a').removeClass('sb_a_active');
      $('.category.filter_all').addClass('active');
    });
    $('.video-collection').on("focus",function() {
        $('.collection-selector').addClass('active');
    });
    $('.video-collection').on("blur",function() {
        $('.collection-selector').removeClass('active');
    });
    $('button.video-coll-btn').click(function(){
      $(this).toggleClass('check');
      if($('button.video-coll-btn.check').length > 0){
        $('.product_img_cont').hide();
        $('button.video-coll-btn.check').each(function(){
          $('.product_img_cont.'+$(this).val()).show(); 
        });
      }else{
        $('.product_img_cont').show();
      }
    });
    
  $(".video-container").click(function(){
//     $(this).click();
     $(this).find(".thumbnail").removeAttr("data-duration");
  });
    $('.select-category').click(function(){
      $(this).toggleClass('active');
      $('.collection-list').toggle();
    })
  $(".product-selector").click(function(){
    $('.videos').hide();
    var id=$(this).data('product');
    $('.product-videos').hide();
    $('.videos-'+id).show();
    $('.sb_single_a').removeClass('sb_a_active');
    $('.sb_single_a.selector-'+id).addClass('sb_a_active');
    $('.category').removeClass('active');
    $('.category.selector-'+id).addClass('active');
    if($(window).width() < 768){
      $('.pre-scrim').css("visibility","hidden");
      $(".sidebar_menu").hide();
    }
  });
  $(".sb-home-icon,.sb-home,.filter_all").click(function(){
    $('.videos').show();
    $('.product-videos').hide();
    $('.category').removeClass('active');
    $('.sb_single_a').removeClass('sb_a_active');
    $('.category.filter_all').addClass('active');
  });
  $('.sb-icon.sb-search-icon').click(function(){
    $('.video-search').slideDown(300);
  });
  $('span.search-cross').click(function(){
    $('.video-search').slideUp(300);
    $('.video-search input').val('');
    $("#vid_sb a").show();
  });
  $(document).click(function (e) {
    if ($(e.target).is('.pre-scrim')) {
      $('.pre-scrim').css("visibility","hidden");
      $(".sidebar_menu").hide();
    }
  }); 
    $(".youtube").hover(function(){
      // $(this).find(".youtube__play").toggleClass("yt_hvr");
    });
          
  
    $(window).on("resize", function (e) {
      checkScreenSize();
    });

    checkScreenSize();
    
    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 1025) {
            
          $('.mob_li_sb,.explore').click(function(){
            $('.pre-scrim').css({"opacity":'1','visibility':'visible'});
            $(".sidebar_menu").show();    
        });
          
        }
    }

    $('#product-video-search').keyup(function(e){
        var value = $(this).val().toLowerCase();
        $("#vid_sb a").filter(function() {
          if($(this).text().toLowerCase().indexOf(value) > -1){
            $(this).css('display','block'); 
          }else{
            $(this).hide();
          }
        });
    });

    // new branding js
    $('input#product-video-search2').on('input', function(e) {
        // console.log('in');
        var value = $(this).val().toLowerCase();
        if(value !== ''){
          $("#vid_sb2 a").filter(function() {
            if($(this).text().toLowerCase().indexOf(value) > -1){
              $(this).css('display','block');
              $(this).addClass('shabi-active1');
            }else{
              $(this).hide();
              $(this).removeClass('shabi-active1');
            }
          });

          $(".nb-dm-search-inner-wrapper").addClass('open-search-query');

        }else{
          var value = $(this).val().toLowerCase();
          $("#vid_sb2 a").filter(function() {
            if($(this).text().toLowerCase().indexOf(value) > -1){
              $(this).hide();
              $(this).removeClass('shabi-active1');
            }

          });

          $(".nb-dm-search-inner-wrapper").removeClass('open-search-query');

        }

    });

    // $('input#product-video-search2').on('blur', function(e) {  });

    $(document).click(function(event) {

        if (!$(event.target).closest(' input#product-video-search2').length) {
            console.log("outside");
            $(".nb-dm-search-inner-wrapper").removeClass('open-search-query');

        } else {
            // console.log("inside");
            $(".nb-dm-search-inner-wrapper").addClass('open-search-query');

        }

    });



  

    (function () {
        var v = document.getElementsByClassName("youtube");
        for (var n = 0; n < v.length; n++) {
            var p = document.createElement("div");
            p.innerHTML = labnolThumb(v[n].dataset.id);
            p.onclick = labnolIframe;
            v[n].appendChild(p);
        }
    })();

    function labnolThumb(id) {
        return '<img class="youtube__img" src="//i.ytimg.com/vi/' + id + '/hqdefault.jpg"><div class="youtube__play"></div>';
    }

    function labnolIframe() {
        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", "//www.youtube.com/embed/" + this.parentNode.dataset.id + "?autoplay=1");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        iframe.setAttribute("id", "youtube-iframe");
        iframe.setAttribute("allow", "autoplay");
        this.parentNode.replaceChild(iframe, this);
    }
});  